import { Schema } from "effect";
export type WorkflowJson = typeof Schema.Json.Type;
export function parseWorkflowJson(text: string): { readonly valid: false } | { readonly valid: true; readonly value: WorkflowJson | undefined } {
  if (!text.trim()) return { valid: true, value: undefined };
  try { const value: unknown = JSON.parse(text);return Schema.is(Schema.Json)(value) ? { valid: true, value } : { valid: false }; } catch { return { valid: false }; }
}
